module.exports = __webpack_public_path__ + "components/flag/static/square/gg-69c8f0e5620e6385b6da6982faf3da79.svg";